module.exports = __webpack_public_path__ + "img/achievement.35ca1906.png";